import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, iRootState } from '../redux/store';

const getQuotePaymentStatus = function getQuotePaymentStatus(
  status: string,
  hasTerms: boolean
): string {
  const isPaid = status === 'Paid';
  const isPending = status === 'Pending';
  const partiallyPaidStatus = 'Partially Paid';
  const isUnderReview = status === 'Under Review';

  if (hasTerms) {
    if (isPaid || isPending) {
      return partiallyPaidStatus;
    }
    if (isUnderReview) {
      return status;
    }
  }

  return status;
};

const useUpdatePaymentStatus = function useUpdatePaymentStatus(): {
  updatePaymentStatus: (
    paymentStatus: string,
    transactionId: string | null,
    paymentMethod: number,
    selectedTerms?: number[]
  ) => void;
} {
  const dispatch = useDispatch<Dispatch>();
  const quoteId = useSelector((state: iRootState) => state.quote.id);
  const dealerId = useSelector((state: iRootState) => state.quote.dealerId);
  const updatePaymentStatus = async (
    paymentStatus: string,
    transactionId: string | null,
    paymentMethod: number,
    selectedTerms?: number[]
  ) => {
    const savePaymentStatusResults = await dispatch.currencyPay.savePaymentStatus(
      {
        quoteId,
        paymentStatus,
        transactionId,
        paymentMethod,
        selectedTerms,
        companyId: dealerId
      }
    );

    const hasTerms = Array.isArray(selectedTerms) && selectedTerms.length > 0;
    const quotePaymentStatus = getQuotePaymentStatus(paymentStatus, hasTerms);
    await dispatch.quote.setPaymentStatus(quotePaymentStatus);

    if (hasTerms) {
      await dispatch.paymentTerms.setPaymentTerms(savePaymentStatusResults);
    }
  };

  return { updatePaymentStatus };
};
export default useUpdatePaymentStatus;
